import { Children, cloneElement } from 'react';

import { usePopoverContext } from './context';

import type { FC, ReactElement } from 'react';

export interface ToggleProps {
  children: ReactElement[];
}

export const PopoverHoverLeave: FC<ToggleProps> = ({ children }) => {
  const { handleClose } = usePopoverContext();

  return (
    <>
      {Children.map(children, (child) =>
        cloneElement(child, {
          onMouseLeave: handleClose,
        })
      )}
    </>
  );
};
